/* import __COLOCATED_TEMPLATE__ from './related-content-panel.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type { EntityType } from 'embercom/models/data/entity-types';
import { objectIcons, objectTypes } from 'embercom/models/data/matching-system/matching-constants';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type { RelatedContentEntity } from 'embercom/services/suggestion-service';

interface Args {
  loadedRelatedEntities: RelatedContentEntity[];
  isLoadingRelatedContent: boolean;
}

export default class RelatedContentPanel extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare intl: $TSFixMe;

  @tracked showSidePanel = false;
  @tracked selectedEntity: RelatedContentEntity | null = null;

  getIconForEntityType(entityType: EntityType): InterfaceIconName {
    return objectIcons[entityType] || 'article';
  }

  @action
  getEntityTypeName(entityType: EntityType | undefined): string {
    if (entityType === undefined) {
      return '';
    }
    let entityTypeToName = {
      [objectTypes.articleContent]: 'public-article',
      [objectTypes.contentSnippet]: 'snippet',
      [objectTypes.internalArticle]: 'internal-article',
    };
    let entityName = entityTypeToName[entityType];

    if (!entityName) {
      return '';
    }

    return this.intl.t(`automation.ai-insights.related-content-panel.${entityName}`);
  }

  @action
  onClose() {
    this.showSidePanel = false;
    this.selectedEntity = null;
  }

  @action
  openSidePanel(entity: RelatedContentEntity) {
    this.selectedEntity = entity;
    this.showSidePanel = true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::RelatedContentPanel': typeof RelatedContentPanel;
    'reporting/automation/ai-insights/related-content-panel': typeof RelatedContentPanel;
  }
}
